import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { VendorsPriceList } from "../vendors-price-list/entities/vendor-price-list.entity";
import { Brands } from "../end-customer/brands.entity";
import { ItemCategory } from "../item-categories/item-categories.entity";
import { Variant } from "../item-varient/item-variant.entity";
import { Sizes } from "../sizes/sizes-entity";
import { SkuCodes } from "../sku-codes/sku-codes.entity";
import { Uoms } from "../uoms/uom.entity";
import { Product } from "../products/product.entity";
import { ItemSubCategory } from "../item-sub-categories/item-sub-category.entity";
import { FoodType } from "../food-types/food-types.entitiy";
import { ValueAdditionOneType } from "../value-addition1-types/value-addition-one.entity";
import { ValueAdditionTwoType } from "../value-addition2-types/value-addition-two.entity";
import { ValueAdditionThreeType } from "../value-addition3-types/value-addition-three.entity";
import { ValueAdditionFourType } from "../value-addition4-types/value-addition-four.entity";
import { ValueAdditionFiveType } from "../value-addition5-types/value-addition-five.entity";
import { MasterBrand } from "../master-brands/master-brands.entity";
import { GlobalStatus } from "@gtpl/shared-models/common-models";


@Entity('items')
export class Item {

  @PrimaryGeneratedColumn("increment", { name: 'item_id' })
  itemId: number;

  @Column("varchar", {
    nullable: false,
    length: 255,
    name: "item_name"
  })
  itemName: string;

  @Column("varchar", {
    nullable: true,
    length: 255,
    name: "bap_no"
  })
  bapNo: string;

  @Column("varchar", {
    nullable: true,
    length: 40,
    name: "item_code"
  })
  itemCode: string;
  @Column("varchar", {
    nullable: true,
    length: 40,
    name: "product_code"
  })
  productCode: string;
  @Column("int", {
    nullable: false,
    default: 0,
    name: "count"
  })
  count: number;

  // @Column("int", {
  //   nullable: false,
  //   name: "item_category_id"
  // })
  // itemCategoryId: number;

  @Column("varchar", {
    nullable: true,
    name: "packing_category"
  })
  packingCategory: string;
  // @Column("int", {
  //   nullable: false,
  //   name: "brand"
  // })
  // brandId: number;
  // @Column("int", {
  //   nullable: false,
  //   name: "sku_code_id"
  // })
  // varientId: number;
  @Column("varchar", {
    nullable: true,
    name: "min_grade"
  })
  minGrade: number;

  @Column("varchar", {
    nullable: true,
    name: "max_grade"
  })
  maxGrade: number;
  @Column("varchar", {
    nullable: true,
    name: "pouches"
  })
  pouches: number;

  @Column({
    type: "decimal", precision: 10, scale: 3,
    nullable: true,
    name: "pouch_weight"
  })
  pouchWeight: number;
  // @Column("int", {
  //   nullable: false,
  //   name: "size_id"
  // })
  // sizeId: number;
  @Column("int", {
    nullable: true,
    default: 0,
    name: "min_qnty"
  })
  minimumQuantity: number;
  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "remarks"
  })
  remarks: string;

  @Column("varchar", {
    nullable: true,
    length: 50,
    name: "approval_no"
  })
  approvalNo: string;

  @Column("int", {
    nullable: true,
    name: "type_id"
  })
  type: number;

  @Column("int", {
    nullable: true,
    name: "net_weight"
  })
  netWeight: number;
  @Column({
    type: 'enum',
    enum : GlobalStatus,
    nullable: true,
    name: 'is_preperation_required',
    default:GlobalStatus.YES
  })
  isPreperationRequired : GlobalStatus;
  @Column({
    type: 'enum',
    enum : GlobalStatus,
    nullable: false,
    name: 'is_asset',
    default:GlobalStatus.NO
  })
  isAsset : GlobalStatus;

  @Column('varchar',{
    name:'asset_type'
  })
  assetType: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;
  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

@Column("int",{
nullable:true,
name:"asset_sla",
})
assetSla:number;

@Column('varchar',{
  nullable:true,
  name:'asset_priority'
})
assetPriority:string


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type => VendorsPriceList, venPrcList => venPrcList.items)
  vendorsPriceList: VendorsPriceList[];

  @ManyToOne(type => ItemCategory, itemCategory => itemCategory.itemInfo, { nullable: false, })
  @JoinColumn({ name: "item_category_id" })
  itemCategoryInfo: ItemCategory;

  @ManyToOne(type => ItemSubCategory, itemSubCategory => itemSubCategory.itemInfo, { nullable: true, })
  @JoinColumn({ name: "item_sub_category_id" })
  itemSubCategory: ItemSubCategory;

  @ManyToOne(type => MasterBrand, brands => brands.itemInfo, { nullable: true, })
  @JoinColumn({ name: "brand" })
  brandsInfo: MasterBrand;

  @ManyToOne(type => Product, products => products.itemInfo, { nullable: true, })
  @JoinColumn({ name: "product_id" })
  productInfo: Product;

  @ManyToOne(type => SkuCodes, variant => variant.itemInfo, { nullable: true, })
  @JoinColumn({ name: "sku_code_id" })
  skuInfo: SkuCodes;

  @ManyToOne(type => Sizes, sizes => sizes.itemInfo, { nullable: true, })
  @JoinColumn({ name: "size_id" })
  sizeInfo: Sizes;

  @ManyToOne(type => Uoms, uom => uom.itemInfo, { nullable: true, })
  @JoinColumn({ name: "uom_id" })
  uomInfo: Uoms;

  @ManyToOne(type => FoodType, foodType => foodType.foodTypeId, { nullable: true, })
  @JoinColumn({ name: "food_type_id" })
  foodTypeInfo: FoodType;

  @ManyToOne(type => ValueAdditionOneType, valueAdditionOneType => valueAdditionOneType.valueAdditionOneId, { nullable: true, })
  @JoinColumn({ name: "value_addition_one_id" })
  valueAdditionOneTypeInfo: ValueAdditionOneType;
  @ManyToOne(type => ValueAdditionTwoType, valueAdditionTwoType => valueAdditionTwoType.valueAdditionTwoId, { nullable: true, })
  @JoinColumn({ name: "value_addition_two_id" })
  valueAdditionTwoTypeInfo: ValueAdditionTwoType;
  @ManyToOne(type => ValueAdditionThreeType, valueAdditionThreeType => valueAdditionThreeType.valueAdditionThreeId, { nullable: true, })
  @JoinColumn({ name: "value_addition_three_id" })
  valueAdditionThreeTypeInfo: ValueAdditionThreeType;
  @ManyToOne(type => ValueAdditionFourType, valueAdditionFourType => valueAdditionFourType.valueAdditionFourTypeInfo, { nullable: true, })
  @JoinColumn({ name: "value_addition_four_id" })
  valueAdditionFourTypeInfo: ValueAdditionFourType;
  @ManyToOne(type => ValueAdditionFiveType, valueAdditionFiveType => valueAdditionFiveType.valueAdditionFiveTypeInfo, { nullable: true, })
  @JoinColumn({ name: "value_addition_five_id" })
  valueAdditionFiveTypeInfo: ValueAdditionFiveType;
}
